export default __webpack_public_path__ + "static/media/Parches_2.984fe117.png";